import { Injectable } from "@angular/core";
import { TagRepository } from "../../../../core/repositories";
import { BaseResponse, Tag } from "../../../../core/domain/models";
import { CreateUpdateTagRequest } from "../../../../core/domain/requests";
import { catchError, map, mergeMap, Observable, of, reduce } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { TagApiUrlsEnum } from "./tag-api-urls.enum";
import { TagWebEntity } from "./tag.web-entity";
import { TagWebRepositoryMapper } from "./tag.web-repository-mapper";
import { injectEnvironment } from "master-locations-library/master-locations-library/src/lib/core/environments/environment.token";

@Injectable()
export class TagWebRepository extends TagRepository {

  environment = injectEnvironment();
  
  constructor(private httpClient: HttpClient) {
    super();
  }

  getTags(): Observable<Tag[]> {
    const mapper = new TagWebRepositoryMapper();
    return this.httpClient
      .get<BaseResponse<TagWebEntity[]>>(`${this.environment.url}${TagApiUrlsEnum.GetTags}`)
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(reduce((items: Tag[], item: Tag) => [...items, item], []));
  }

  getTagsLookup(): Observable<Tag[]> {
    const mapper = new TagWebRepositoryMapper();
    return this.httpClient
      .get<BaseResponse<TagWebEntity[]>>(`${this.environment.url}${TagApiUrlsEnum.GetTagsLookup}`)
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(reduce((items: Tag[], item: Tag) => [...items, item], []));
  }

  createEditTag(request: CreateUpdateTagRequest): Observable<boolean> {
    return this.httpClient.post<BaseResponse<string>>(`${this.environment.url}${TagApiUrlsEnum.CreateEditTag}`, request)
      .pipe(
        map((response) => response.successful),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      );
  }

  deleteTag(id: string): Observable<boolean> {
    return this.httpClient
      .delete<BaseResponse<unknown>>(`${this.environment.url}${TagApiUrlsEnum.DeleteTag}`, { params: new HttpParams().set("id", id) })
      .pipe(
        map((response) => response.successful),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      );
  }
}
